// @ts-nocheck
/* eslint-enable */
// App
import React from 'react';

// Misc / utils
import * as S from './styles';

const Calendar = ({ customRef, handleOnDayClick, today, from, to, handleEsc }) => {
  const modifiers = {
    disabled: function disabled(d1) {
      const d2 = today;

      if (d1.getFullYear() < d2.getFullYear()) {
        return true;
      }
    },
    selected: function selected(d1) {
      const d2 = today;

      return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
    },
    end: to,
  };

  return (
    <S.StyledDayPicker
      showOutsideDays
      numberOfMonths={1}
      selectedDays={[from, { from, to }]}
      modifiers={modifiers}
      onDayClick={handleOnDayClick}
      onKeyDown={handleEsc}
      disabledDays={{ before: today }}
      labels={{
        nextMonth: 'Next Month',
        previousMonth: 'Previous Month',
      }}
      ref={customRef}
    />
  );
};

export default Calendar;
